import React from 'react';
import { BaseUnmetDemandSystemSection } from './BaseUnmetDemandSystemSection';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import { useTheme } from '@mui/material/styles';

// --- MODIFIED: Added scenarioName and hazardLabel to props ---
export const UnmetDemandPowerSystemSection = ({
    analysisData,
    nameMap,
    floodData,
    scenarioId,
    llmSummaries,
    scenarioName,
    hazardLabel
}) => {
    const theme = useTheme();
    const systemLabel = "Electricity Supply";
    
    return (
        <BaseUnmetDemandSystemSection
            analysisData={analysisData}
            nameMap={nameMap}
            systemKey="power"
            sectionTitle={`${systemLabel} system infrastructures with shortage risks`}
            systemIcon={ElectricalServicesIcon}
            systemColor={theme.palette.error.main}
            floodData={floodData}
            scenarioId={scenarioId}
            // --- MODIFIED: Pass the new props down ---
            scenarioName={scenarioName}
            hazardLabel={hazardLabel}
            // --- FIXED: Changed prop name from llmSummary to the expected llmInsights ---
            llmInsights={llmSummaries?.systems?.power}
        />
    );
};